import React from 'react';
import { Tabs, TABS_VARIANTS } from 'afl-design-system';

export const TabsDemo = () => {
    const standardTabsMedium = [
        {
            id: 1,
            value: 'labelOne',
            name: 'Label One',
            url: '#label-one'
        },
        {
            id: 2,
            value: 'labelTwo',
            name: 'Label Two with long name',
            url: '#label-two'
        },
        {
            id: 3,
            value: 'labelThree',
            name: 'Label Three'
        },
        {
            id: 4,
            value: 'labelFour',
            name: 'Label Four with long name',
            url: '#label-four'
        },
        {
            id: 5,
            value: 'labelFive',
            name: 'Label Five',
            url: '#label-five'
        }
    ];

    const tabsStandardClass = '';

    return (
        <div className="flex flex-column">
            <h3 className="text-title-m">Tabs</h3>
            <div className="mt-m flex gap-s items-center flex-wrap">
                {Object.keys(TABS_VARIANTS.VARIANT)
                    .map((variantKey) =>
                        Object.keys(TABS_VARIANTS.SIZE)
                            .map((sizeKey) => (
                                <Tabs
                                    key={`tabs-${variantKey}-${sizeKey}`}
                                    className={tabsStandardClass}
                                    defaultValue="labelTwo"
                                    variant={TABS_VARIANTS.VARIANT[variantKey]}
                                    size={TABS_VARIANTS.SIZE[variantKey]}
                                    tabs={standardTabsMedium}
                                />
                            ))
                            .flat()
                    )
                    .flat()}
            </div>
        </div>
    );
};
